import React from "react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { toast } from "sonner";
import { Languages } from "lucide-react";

export default function Settings() {
  const { user, updateSettings } = useAuth();
  const { t, lang, setLang } = useI18n();

  const savePref = async (lng) => {
    setLang(lng);
    try {
      await updateSettings({ language_pref: lng });
      toast.success(t("saved"));
    } catch {}
  };

  return (
    <div className="space-y-10 max-w-2xl" data-testid="settings-page">
      <div>
        <div className="font-mono text-xs uppercase tracking-[0.2em] text-gray-500 mb-3">/ {t("settings")}</div>
        <h1 className="font-display font-black text-4xl md:text-5xl tracking-tighter">Settings</h1>
      </div>

      <section className="border border-black/10 p-6 space-y-5">
        <div className="flex items-center gap-3">
          <Languages className="w-5 h-5" />
          <h2 className="font-display font-bold text-xl">{t("language")}</h2>
        </div>
        <div className="flex gap-3">
          {[
            { v: "en", label: "English" },
            { v: "ar", label: "العربية (RTL)" },
          ].map((o) => (
            <button
              key={o.v}
              onClick={() => savePref(o.v)}
              className={`px-6 py-3 font-bold text-sm border transition-colors ${
                lang === o.v ? "bg-black text-white border-black" : "border-black/20 hover:border-black"
              }`}
              data-testid={`lang-${o.v}`}
            >
              {o.label}
            </button>
          ))}
        </div>
      </section>

      <section className="border border-black/10 p-6 space-y-4">
        <h2 className="font-display font-bold text-xl">Account</h2>
        <div className="grid grid-cols-[auto_1fr] gap-x-8 gap-y-3 text-sm">
          <span className="text-gray-500">Name</span>
          <span className="font-medium">{user?.full_name}</span>
          <span className="text-gray-500">Login email</span>
          <span className="font-mono">{user?.email}</span>
          <span className="text-gray-500">Platform email</span>
          <span className="font-mono text-[#0033FF]">{user?.platform_email}</span>
          <span className="text-gray-500">Plan</span>
          <span className="uppercase font-mono text-xs tracking-widest">{user?.subscription}</span>
          <span className="text-gray-500">Consent</span>
          <span>{user?.consent_accepted ? "Accepted" : "Not accepted"}</span>
        </div>
      </section>
    </div>
  );
}
